import './download-module.scss';
import { TabBar } from '../../components/tab-bar/tab-bar';

class DownloadModule {
    constructor ($element, options) {
        this.$downloadModule = $element;
        this.$tabBar = this.$downloadModule.querySelector('[data-tab-bar-root="manual"]');
        this.resizeHandler = options.resizeHandler;
        this.firstInit = true; // prevent binding events twice on initial load
    }

    init () {
        if (this.$tabBar) {
            this.tabBar = new TabBar({
                $tabBar: this.$tabBar,
                resizeHandler: this.resizeHandler,
                initContent: ($content) => {
                    this.initSubModules($content);
                }
            });
            this.tabBar.init();
        }
        this.initSubModules(this.$downloadModule);
    }

    // init different sub modules here
    initSubModules ($content) {
        // init standard content modules
        if (!this.firstInit) {
            const contentUpdateEvent = new CustomEvent('content.loaded', {
                view: window,
                bubbles: true,
                cancelable: false,
                detail: {
                    $context: $content
                }
            });

            window.dispatchEvent(contentUpdateEvent);
        }
        this.firstInit = false;
    }
}

export { DownloadModule };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$downloadModules = $context.querySelectorAll('[data-download-module="root"]');

        if ($$downloadModules.length > 0) {
            for (let i = 0; i < $$downloadModules.length; i++) {
                const downloadModule = new DownloadModule($$downloadModules[i], {
                    resizeHandler: window.resizeHandler
                });
                downloadModule.init();
            }
        }
    }
});
